import React, { useState, useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import LoadingSpinner from './LoadingSpinner';

/**
 * RouterTransition component that shows a loading spinner during page transitions
 * This component should be placed inside the Router but outside the Routes component
 */
const RouterTransition = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // Start loading when navigation begins
    setIsLoading(true);

    // Create a timeout to simulate minimum loading time and prevent flashes
    const minLoadingTime = setTimeout(() => {
      // Images and other resources might still be loading, but we'll show the page
      // after a minimum time to prevent the spinner from flashing too quickly
      setIsLoading(false);
    }, 1100); // Matches the loader's full cycle so the separate-and-merge completes

    // Listen for when the page has fully loaded
    const handlePageLoad = () => {
      clearTimeout(minLoadingTime);
      setIsLoading(false);
    };

    // When all resources are loaded, hide the spinner
    window.addEventListener('load', handlePageLoad);

    // Cleanup
    return () => {
      clearTimeout(minLoadingTime);
      window.removeEventListener('load', handlePageLoad);
    };
  }, [location.pathname, navigationType]);

  return (
    <>
      {isLoading && <LoadingSpinner size="xl" color="primary" fullScreen={true} />}
      {children}
    </>
  );
};

export default RouterTransition;
